<template>
  <div class="header">
    <a href="#" class="title">Lottery-ERP</a>
    <div>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <div class="demo-type">
            <div>
              <el-avatar :src="avatarSrc"></el-avatar>
            </div>
          </div>
        </span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-edit" command="个人信息"
            >个人信息</el-dropdown-item
          >
          <!-- @click.native="" 方法编写 -->
          <el-dropdown-item
            icon="el-icon-s-operation"
            command="退出登录"
            @click.native="quitLogin()"
            >退出登录</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      avatarSrc:
        "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
    };
  },
  methods: {
    handleCommand(command) {
      this.$message(`${command}`);
    },
    quitLogin() {
      //通过在 index.js 中为登陆组件写的路由名字，进行路由的跳转
      this.$router.push("Login");
    },
  },
};
</script>
<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.title {
  color: #333;
  font-size: 20px;
  font-weight: bold;
  text-decoration: none;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.demo-type > div {
  display: flex;
  align-items: center;
}

.el-avatar {
  margin-right: 10px;
}
</style>